import { useTheme } from "../context/ThemeContext";

const VAGARO_URL = "https://www.vagaro.com/axtreme/services";

export default function Booking() {
  const t = useTheme();
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 text-center" data-testid="booking-page">
      <div className="text-[11px] tracking-[0.4em] uppercase opacity-70" style={{ color: t.primary }}>Book Appointment</div>
      <h1 className="mt-4 text-5xl sm:text-6xl" style={{ color: t.text }}>Reserve your visit</h1>
      <p className="mt-6 text-lg italic opacity-85 max-w-xl mx-auto" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
        Choose your service, stylist and time on Vagaro — secure, simple, and instantly confirmed.
      </p>
      <a
        href={VAGARO_URL}
        target="_blank"
        rel="noreferrer"
        className={`mt-10 inline-block px-12 py-4 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`}
        data-testid="booking-vagaro-cta"
      >
        Book on Vagaro
      </a>
      <p className="mt-6 text-xs tracking-[0.2em] uppercase opacity-60">Powered by Vagaro</p>

      <div className="mt-20 text-left grid sm:grid-cols-2 gap-6">
        <div className="p-6 bg-white border border-[#E5E5E5]" style={{ borderBottom: `3px solid ${t.primary}` }}>
          <div className="text-xs uppercase tracking-[0.3em]" style={{ color: t.primary }}>Need help?</div>
          <p className="mt-3 text-sm opacity-80">Our team can guide you through service selection, pricing and scheduling — just reach out.</p>
          <a href="tel:+15550150188" className="mt-4 inline-block text-sm underline">Call us · +1 (555) 015-0188</a>
        </div>
        <div className="p-6 bg-white border border-[#E5E5E5]" style={{ borderBottom: `3px solid ${t.primary}` }}>
          <div className="text-xs uppercase tracking-[0.3em]" style={{ color: t.primary }}>Walk-ins</div>
          <p className="mt-3 text-sm opacity-80">Limited walk-in slots available daily based on stylist availability. Booking ahead is recommended.</p>
        </div>
      </div>
    </div>
  );
}
